import React, { useEffect, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import ShareOption, { ShareOptionProps } from './ShareOption';
import { elById, share } from '~/Share/Utils';
import { ReduxState } from '~/types/redux/share';

const defaultShareOptions: ShareOptionProps[] = [
  {
    label: 'Share to twitter',
    icon: 'twitter',
    background: '#55ACEE',
    color: '#ffffff',
    onClick: () => share('twitter'),
  },
  {
    label: 'Share on Facebook',
    icon: 'facebook-f',
    background: '#3B579D',
    color: '#ffffff',
    onClick: () => share('facebook'),
  },
  {
    label: 'Share on LinkedIn',
    icon: 'linkedin-in',
    background: '#2485AF',
    color: '#FFFFFF',
    onClick: () => share('linkedIn'),
  },
];

export type SideShareOptions = {
  options?: ShareOptionProps[];
  slug?: string;
};

export default function SideShare({
  options: initialOptions = defaultShareOptions,
  slug,
}: SideShareOptions) {
  const [options, setOptions] = useState(initialOptions);
  const { shareModalClicked } = useSelector((state: ReduxState) => ({
    shareModalClicked: state.tracking.shareModalClicked,
  }));

  const shareCb = useCallback(() => {
    if (!slug) return;

    const sharingModal = elById('sharing-modal');
    sharingModal?.classList.add('in');

    shareModalClicked();
  }, [slug]);

  useEffect(() => {
    if (slug) {
      setOptions([
        ...options,
        {
          label: 'Share this link',
          icon: 'share-square',
          iconStyle: 'far',
          background: '#EEEEEE',
          color: '#111',
          onClick: shareCb,
        },
      ]);
    }
  }, []);

  return (
    <div className='share-tab'>
      {options.map((option, i) => (
        <ShareOption key={i} {...option} />
      ))}
    </div>
  );
}
